export default {"src":"/_next/static/media/verification-identite.324cd045.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};